import packageJson from '../../package.json';
import { DEV, LOCAL, PRO, UAT } from './env';

export const env = PRO;

export const app = {
    server: {
        local: 'http://localhost:3000',
        dev: 'https://go.makeitsimple.hk:8043',
        uat: 'https://yamazaki-api-gateway-uat.azurewebsites.net',
        pro: 'https://yamazaki-api-gateway.azurewebsites.net',
    },
    baseurl: {
        local: '/yamazaki-website/build/',
        dev: '/yamazaki-website/build/',
        uat: '/',
        pro: '/',
    },
};

export const baseurl = {
    path: app.baseurl[env],
};

export const server = {
    url: app.server[env],
    client_id: 'web-client-id',
    client_secret: 'qk5NdmDeCYW4mnSiAYMxV9b5vpb2XyII',
};

export const upload = {
    max_image_size: 1024 * 1024 * 10, //10M
};

export const languageObj = {
    hk: {
        languageId: 'hongkong',
        locale: 'zh-Hant',
        name: '繁體中文'
    },
    en: {
        languageId: 'english',
        locale: 'en',
        name: 'English'
    }
};

export const firebaseConfig = {
    apiKey: "AIzaSyComiAramqfNIJL_ZJleECSHYkW6IdeCuU",
    authDomain: "yamazaki-hk-website.firebaseapp.com",
    projectId: "yamazaki-hk-website",
    storageBucket: "yamazaki-hk-website.firebasestorage.app",
    messagingSenderId: "112396304871",
    appId: "1:112396304871:web:aff98a0f32c64ebc9fbd42",
    measurementId: "G-3GYMYWDKS0"
};

export const version = packageJson.version;
export const version_display = 'v' + version + (env === PRO ? '' : '.' + env);
